import React from 'react';
import { Formik, Form, FormikConfig } from 'formik';
import { observer } from 'mobx-react-lite';

import { Yup, email, password, handleFormikParallelSubmit } from 'src/helpers';
import { useStore } from '@src/models';
import { Modal, ModalProps, BaseBox, Flex } from 'src/kit';
import { FormikInput, FormikSubmitButton } from '@src/features/common';

const validationSchema = Yup.object({
  email,
  password
});

type SignInModalProps = ModalProps &
  Partial<FormikConfig<any>> & {
    children: {
      title?: React.ReactNode;
      footer?: React.ReactNode;
    };
  };

export const SignInModal = observer(function SignInModal({
  initialValues,
  onClose,
  children: { title, footer }
}: SignInModalProps) {
  const { authStore } = useStore();
  const handleSubmit = (values, actions) => {
    handleFormikParallelSubmit({ requests: authStore.signIn(values), actions });
  };

  const initValues = {
    ...validationSchema.default(),
    ...initialValues
  };

  return (
    <Modal onClose={onClose} py={0} px={0}>
      <Flex alignItems="center" justifyContent="center" bg="primary" color="white" fontSize={20} height="52px">
        Sign In
      </Flex>
      <BaseBox p="40px">
        {title}
        <Formik initialValues={initValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
          {({ isSubmitting }) => (
            <Form>
              <FormikInput name="email" type="email" placeholder="Login" mb={20} variant="auth" />
              <FormikInput name="password" type="password" placeholder="Password" mb={30} variant="auth" />
              <Flex justifyContent="flex-end">
                <FormikSubmitButton variant="primary" size="md">
                  {isSubmitting ? 'Signing in...' : 'Sign in'}
                </FormikSubmitButton>
              </Flex>
            </Form>
          )}
        </Formik>
        {footer}
      </BaseBox>
    </Modal>
  );
});

SignInModal.defaultProps = {
  children: {}
};
